<template>
  <v-app-bar app class="px-8" color="#111111" dark flat >

    <!-- <v-spacer></v-spacer> -->
    <v-btn text @click="scroll('intro')">About me</v-btn>
    <v-btn text @click="scroll('quote')">Quotes</v-btn>
    <v-btn text @click="scroll('learnings')">Interests</v-btn>
    <v-btn text @click="scroll('work')">Portfolio</v-btn>
    <v-btn text @click="scroll('blog')">Blogs</v-btn>
    <v-btn text @click="scroll('contact')"> Connect</v-btn>
  </v-app-bar>
</template>

<script>
export default {
  methods: {
    scroll(refName) {
      const element = document.getElementById(refName);
      element.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style>
* {
  font-style: inherit;
  font-family: inherit;
}
.v-toolbar__content{
  display: flex;
  margin: 0; /*this will remove the empty spaces/margins coming around */
  padding: 0;
  justify-content: center;
}
</style>